export default __webpack_public_path__ + "static/media/mobile_favourite-partners.fccb66bf.png";